<template>
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <!-- Left side - Hero/Branding -->
      <div class="col-lg-6 d-flex align-items-center justify-content-center bg-primary text-white">
        <div class="text-center">
          <h1 class="display-4 fw-bold mb-4">Design.AppVido</h1>
          <p class="lead mb-4">Beautiful Gallery Experience</p>
          <p class="mb-0">Discover stunning photos in an elegant gallery interface</p>
        </div>
      </div>
      
      <!-- Right side - Login Form -->
      <div class="col-lg-6 d-flex align-items-center justify-content-center">
        <div class="w-100" style="max-width: 400px;">
          <div class="card shadow-lg border-0">
            <div class="card-body p-5">
              <h2 class="card-title text-center mb-4">Welcome Back</h2>
              
              <div v-if="error" class="alert alert-danger" role="alert">
                {{ error }}
              </div>
              
              <form @submit.prevent="login">
                <div class="mb-3">
                  <label for="email" class="form-label">Email Address</label>
                  <input 
                    type="email" 
                    class="form-control" 
                    id="email" 
                    v-model="loginForm.email"
                    required
                  >
                </div>
                
                <div class="mb-4">
                  <label for="password" class="form-label">Password</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="password" 
                    v-model="loginForm.password"
                    required
                  >
                </div>
                
                <button 
                  type="submit" 
                  class="btn btn-primary w-100 mb-3"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ loading ? 'Signing In...' : 'Sign In' }}
                </button>
              </form>
              
              <div class="text-center">
                <p class="mb-0">Don't have an account? 
                  <router-link to="/signup" class="text-decoration-none">Sign up here</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    async login() {
      this.loading = true
      this.error = ''
      
      try {
        const response = await axios.post('https://designappvido-backend.up.railway.app/api/login', this.loginForm)
        
        // Store only token
        localStorage.setItem('token', response.data.access_token)
        
        // Redirect to gallery
        this.$router.push('/gallery')
      } catch (error) {
        this.error = error.response?.data?.detail || 'Login failed'
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    // Check if user is already logged in
    const token = localStorage.getItem('token')
    if (token) {
      this.$router.push('/gallery')
    }
  }
}
</script>

<style scoped>
.vh-100 {
  min-height: 100vh;
}

.bg-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.card {
  border-radius: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}
</style>